import React, { forwardRef } from 'react';
import s from './s.module.less';
import BasicInfoStep from '../BasicInfoStep';
import LicenseStep from '../LicenseStep';
import InsuranceStep from '../InsuranceStep';
import ProfessionalProfileStep from '../ProfessionalProfileStep';
import BackgroundStep from '../BackgroundStep';

const ReviewStep: React.FC = () => {
    const steps = [
        { id: 1, component: <BasicInfoStep isReview /> },
        { id: 2, component: <LicenseStep isReview /> },
        { id: 3, component: <InsuranceStep isReview /> },
        { id: 4, component: <ProfessionalProfileStep isReview /> },
        { id: 5, component: <BackgroundStep isReview /> },
    ];

    return (
        <div className={s.reviewStep}>
            <div className={s.sections}>
                {steps.map((step) => (
                    <div key={step.id} className="mb-6">
                        {step.component}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReviewStep;
